<template>
  <div class="emoji_com" @click.stop v-if="value">
    <van-swipe
      class="swiper-wrap"
      ref="mySwiper"
      :autoplay="0"
      loop
      :touchable="true"
      :stop-propagation="false"
    >
      <van-swipe-item v-for="(item,index) in emojiList" :key="index" class="emoji_list">
        <div
          v-for="(item2,index2) in item"
          :key="index2"
          @click="sendEmoji(item2.key)"
          class="emojiBox needsclick"
        >
          <span class="emoji_pic needsclick">{{item2.emoji}}</span>
        </div>
        <img
          @click="deleteEmoji"
          class="delete_emoji needsclick"
          src="http://cdn.yxvzb.com/WEB/wx-master/images/%E5%88%A0%E9%99%A4@2x.png"
          alt
        />
      </van-swipe-item>
      <!-- 常见的小圆点 -->
      <div class="swiper-pagination" v-for="(item,index) in emojiList" :key="index" slot="pagination"></div>
    </van-swipe>
  </div>
</template>
<script>
import emojiList from 'node-emoji'
let emoji = emojiList.search("").slice(859, 928);
let num = 23; //每个子数组里的元素个数
let Arr = new Array(Math.ceil(emoji.length / num));
for (let i = 0; i < Arr.length; i++) {
  Arr[i] = new Array();
  for (let j = 0; j < num; j++) {
    Arr[i][j] = "";
  }
}
for (let i = 0; i < emoji.length; i++) {
  Arr[parseInt(i / num)][i % num] = emoji[i];
}
export default {
  name: 'emoji',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pageIndex: 0,
      emojiList: []
    };
  },
  methods: {
    onIndexChange(index) {
      this.pageIndex = index;
    },
    // 发送表情
    sendEmoji(data) {
      this.$emit('sendFatherEmoji', data);
    },
    // 删除表情
    deleteEmoji() {
      this.$emit('deleteFatherEmoji', 0);
    }
  },
  components: {},
  watch: {},
  created() {
    this.emojiList = Arr;
  }
};
</script>
<style lang="less" scoped>
.emBox {
  width: 10rem;
}
.emoji_com {
  position: fixed;
  left: 0;
  bottom: 1.5rem;
  width: 100vw;
  height: 4.44rem;
  background: #f9f9f9;
  transition: all linear 0.2s;
  .emoji_list {
    padding: 0.37rem 0.37rem 0.37rem 0.9rem;
    display: flex;
    flex-wrap: wrap;
    // width: 100% !important;
    .emojiBox {
      width: 0.7rem;
      height: 1.16rem;
      margin-right: 10px;
    }
    .emoji_pic {
      // margin-right: 0.25rem;
      font-size: 0.6rem;
    }
  }
  .delete_emoji {
    margin-top: 0.2rem;
    width: 0.61rem;
    height: 0.5rem;
  }
}
</style>
<style lang="less">
</style>
